<template>
    <v-card flat class="score-trans" :height="getPanelHeight()">
        <v-container>
            <v-row dense>
                <v-col cols="12" lg="6"> 
                    <right_panel_bookings ref="rightpanelbookings" :height_correction="this.toolbarheight" :chart_correction="this.captionchartheight"/>
                </v-col>
                <v-col cols="12" lg="6"> 
                    <right_panel_arrivals ref="rightpanelarrivals" :height_correction="this.toolbarheight" :chart_correction="this.captionchartheight"/>
                </v-col>
            </v-row>    
            <v-row dense>
                <v-col cols="12" lg="6"> 
                    <right_panel_year_bookings ref="rightpanelyearbookings" :height_correction="this.toolbarheight" :chart_correction="this.captionchartheight"/>
                </v-col>
                <v-col cols="12" lg="6"> 
                    <right_panel_year_arrivals ref="rightpanelyeararrivals" :height_correction="this.toolbarheight" :chart_correction="this.captionchartheight"/>
                </v-col>
            </v-row>          
            <v-row dense>
                <v-col cols="12"> 
                    <right_panel_performance_table ref="rightpanelperformance" :height_correction="(this.toolbarheight + (this.captionchartheight * 2))"/>
                </v-col>
            </v-row>          
        </v-container>                                 
    </v-card>
  </template>
  
  <script>
  
    import mxscreensize from '@/components/js/screensize';
    import right_panel_bookings from '@/components/dashboard/sections/right_panel_bookings.vue';
    import right_panel_arrivals from '@/components/dashboard/sections/right_panel_arrivals.vue';
    import right_panel_year_bookings from '@/components/dashboard/sections/right_panel_year_bookings.vue';
    import right_panel_year_arrivals from '@/components/dashboard/sections/right_panel_year_arrivals.vue';
    import right_panel_performance_table from '@/components/dashboard/sections/right_panel_performance_table_wrapper.vue';

    export default {
        props: {
            height_correction: Number,
        },               
        components: {
            right_panel_bookings,
            right_panel_arrivals,
            right_panel_year_bookings,
            right_panel_year_arrivals,
            right_panel_performance_table,
        },         
        data() {
            return {
                toolbarheight: 80,
                captionchartheight: 83
                // right_panel_performance table cannot shrink vertically so it is fixed. This height is added to the correction ( was 125)
            }
        },            
        mixins:[mxscreensize],
        created(){
            console.log("window height right panel", this.wInnerHeight, this.$vuetify.breakpoint.name);
        },    
        methods: {
            getPanelHeight(){
                return ( (this.wInnerHeight - (typeof this.height_correction === 'undefined' ? this.toolbarheight : (this.height_correction + this.toolbarheight))));
            },                    
            load(){
                console.log('(re) loading right panel', this.$vuetify.breakpoint.name);
                this.$refs.rightpanelbookings.load();
                this.$refs.rightpanelperformance.load(new Date().getFullYear()); // only load actual data
            }
        }
    }  
  </script>
  
  <style scoped>
    .score-trans {
        background: transparent !important;
    } 
  </style>